import React, { useContext } from "react";
import { connect } from "react-redux";
import { PermissionDeniedToastContext } from "components/dashboard/common/Toast/context/ToastContextProvider";
import { roleHasPermission, mapStateToRolePermissions } from "utils/permissions/rolePermissions";
import "./ComponentAccessControl.scss";

const ComponentAccessControl = ({
    baseResources,
    children,
    role,
    ignorePermissions,
}) => {
    const showPermissionDenied = useContext(PermissionDeniedToastContext);

    const handleAccessControl = (e) => {
        e.stopPropagation();
        e.preventDefault();

        showPermissionDenied?.();
    };

    const hasAccess =
        ignorePermissions || roleHasPermission(role, baseResources);

    return (
        <>
            {hasAccess ? (
                <>{children}</>
            ) : (
                <div
                    onClick={(e) => handleAccessControl(e)}
                    className='component__access__control'
                    title="You don't have permission for this action">
                    <div className='component__access__control--child'>
                        {children}
                    </div>
                </div>
            )}
        </>
    );
};

export default connect((state) => ({
    ...mapStateToRolePermissions(state),
    role: state?.auth?.user?.role,
}))(ComponentAccessControl);
